import { useTheme } from '@mui/material';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { useStylesNavBarLogo } from '../styles/NavbarStyles';
import { getLogo } from '../helpers/Generichelper';
import { getChannelSettingByKey } from '../../routes/generic/Helpers/GenericIndexHelper';
import { useNavigate } from 'react-router';

function Logo({ logoWidth }) {
	const theme = useTheme();
	const navigate = useNavigate();
	const classes = useStylesNavBarLogo(theme, logoWidth);
	const agentDetails = useSelector(({ fuse }) => fuse?.form?.referenceTokenDetails?.agentDetails);
	const companyDetails = useSelector(({ fuse }) => fuse?.form?.companyDetailsResponse?.value);
	const companyLogo = companyDetails?.companyLogoBlobUrl || companyDetails?.logoBlobUrl;
	const isLogoLinkEnabled = getChannelSettingByKey('Logo-Link-Enabled') || 'false';

	const primaryLogo =
		agentDetails?.agentLogoType === 1 && agentDetails?.agentLogoBlobUrl
			? agentDetails?.agentLogoBlobUrl
			: getLogo()?.primaryLogo || companyLogo;

	const handleLogoClick = () => {
		if (isLogoLinkEnabled === 'true') {
			navigate('/');
		}
	};

	return (
		<>
			{primaryLogo && (
				<img
					style={{
						...classes.logo,
						cursor: isLogoLinkEnabled === 'true' ? 'pointer' : 'default'
					}}
					src={primaryLogo}
					alt=""
					onClick={handleLogoClick}
				/>
			)}
		</>
	);
}

Logo.propTypes = {
	className: PropTypes.string,
	logoWidth: PropTypes.string
};

export default Logo;
